import React from 'react';

export interface IIconCheckCircleProps {
  [key: string]: any;
}

const IconCheckCircle: React.FC<IIconCheckCircleProps> = ({
  stroke = Styles.color.primary,
  fill = 'none',
  ...props
}) => (
  <svg width="30" height="30" viewBox="0 0 30 30" {...props}>
    <title>Check Circle</title>
    <g fill={fill} strokeWidth="1.6" fillRule="evenodd">
      <circle stroke={fill} cx="15" cy="15" r="14.2" />
      <g stroke={stroke} strokeLinecap="round" strokeLinejoin="round">
        <path d="M10.32 15.07l2.54 2.74M12.86 17.81l5.93-6.4" />
      </g>
    </g>
  </svg>
);

export default IconCheckCircle;
